import { Image } from 'antd';
import React from 'react';

import { defaultPreview } from './PreviewImage';

import './Image.scss';

export interface PreviewImageGroupProps {
  children: React.ReactNode;
}

export const PreviewImageGroup: React.FC<PreviewImageGroupProps> = ({ children }) => {
  return <Image.PreviewGroup preview={defaultPreview}>{children}</Image.PreviewGroup>;
};
